export default {
	about: 'About us',
	mission: 'Our Mission',
	vision: 'Our Vision',
	policy: 'Our policy',
	qualityPolicy: 'Quality policy'
}